const StudyPlannerSections = {
    home: 0,
    yourDetails: 1,
    groupSelection: 2,
    courseSelection: 3,
    dailyRoutine: 4,
    family: 5,
    work: 6,
    commuting: 7,
    lifestyle: 8,
    scheduler: 9,
}
